<template>
  <div class="product-history-section">
    <h4 class="mb-6">Lịch sử thay đổi sản phẩm</h4>

    <div v-if="loading" class="d-flex justify-content-center py-5">
      <div class="spinner spinner-primary"></div>
    </div>

    <div v-else-if="historyItems.length === 0" class="text-center py-5">
      <p>Chưa có lịch sử thay đổi</p>
    </div>

    <div v-else>
      <b-container class="px-0">
        <b-table
          :fields="historyFields"
          :items="historyItems"
          class="table-bordered table-hover"
        >
          <template v-slot:cell(createdBy)="row">
            <p>{{ row.item.createdBy || 'Hệ thống' }}</p>
            <p>{{ formatDate(row.item.createdAt) }} {{ formatTime(row.item.createdAt) }}</p>
          </template>

          <template v-slot:cell(actionName)="row">
            <p>{{ row.item.actionName }}</p>
          </template>

          <template v-slot:cell(detail)="row">
            <div
              class="history-detail-link"
              @click="viewHistoryDetail(row.item)"
              style="cursor: pointer; color: #3699ff"
            >
              <span>Chi tiết</span>
            </div>
          </template>
        </b-table>
      </b-container>
    </div>

    <b-modal
      ref="history-modal"
      hide-footer
      title="Lịch sử chỉnh sửa"
      size="lg"
    >
      <b-row>
        <b-col md="3">
          <label class="label-sp">Chỉnh sửa bởi: </label>
        </b-col>
        <b-col md="8">
          <label>{{ selectedHistory.createdBy || 'Hệ thống' }}</label>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="label-sp">Chỉnh sửa lúc: </label>
        </b-col>
        <b-col md="9">
          <label>{{ formatDate(selectedHistory.createdAt) }} {{ formatTime(selectedHistory.createdAt) }}</label>
        </b-col>
      </b-row>
      <b-table
        bordered
        hover
        :fields="historyDetailFields"
        :items="selectedHistory.diffValues || []"
      >
        <template v-slot:cell(originalValue)="row">
          <div style="text-align: end" v-if="row.item.isNumber">
            <span v-text="formatValue(row.item.originalValue, row.item.isNumber)"></span>
          </div>
          <span v-else v-text="formatValue(row.item.originalValue, row.item.isNumber)"></span>
        </template>
        <template v-slot:cell(newValue)="row">
          <div style="text-align: end" v-if="row.item.isNumber">
            <span v-text="formatValue(row.item.newValue, row.item.isNumber)"></span>
          </div>
          <span v-else v-text="formatValue(row.item.newValue, row.item.isNumber)"></span>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { makeToastFaile } from '@/utils/common';

export default {
  name: 'ProductHistorySection',

  props: {
    productId: {
      type: [Number, String],
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      historyItems: [],
      pageSize: 10,
      loading: false,
      selectedHistory: {},
      historyFields: [
        { key: 'createdBy', label: 'Người chỉnh sửa' },
        { key: 'actionName', label: 'Hành động' },
        { key: 'detail', label: 'Chi tiết' }
      ],
      historyDetailFields: [
        { key: 'keyName', label: 'Trường' },
        { key: 'originalValue', label: 'Giá trị cũ' },
        { key: 'newValue', label: 'Giá trị mới' }
      ]
    };
  },

  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.productId) {
          this.fetchHistory();
        }
      },
    },

    productId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.resetHistory();
          this.fetchHistory();
        }
      },
    },
  },

  mounted() {
    if (this.productId) {
      this.fetchHistory();
    }
  },

  methods: {
    viewHistoryDetail(item) {
      this.selectedHistory = item || {};
      this.$refs['history-modal'].show();
    },
    
    async fetchHistory() {
      if (!this.productId) return;

      this.loading = true;
      try {
        await this.$store.dispatch('product/fetchProductHistory', {
          productId: this.productId,
        });

        this.historyItems =
          this.$store.getters['product/getProductHistory'] || [];
      } catch (error) {
        makeToastFaile(error.data.message || 'Lỗi khi tải dữ liệu');
        this.historyItems = [];
      } finally {
        this.loading = false;
      }
    },


    resetHistory() {
      this.historyItems = [];
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },

    formatTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleTimeString('vi-VN', {
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    formatValue(value, isNumber) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }

      if (isNumber && typeof value === 'number') {
        return new Intl.NumberFormat('vi-VN').format(value);
      }

      return value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.product-history-section {
  padding: 1rem;
  .history-detail-link {
    &:hover {
      text-decoration: underline;
    }
  }

  .label-sp {
    font-weight: bold;
  }
}
</style>
